import { render, staticRenderFns } from "./FittingsCheck.vue?vue&type=template&id=1d4f8ad0&scoped=true"
import script from "./FittingsCheck.vue?vue&type=script&lang=js"
export * from "./FittingsCheck.vue?vue&type=script&lang=js"
import style0 from "./FittingsCheck.vue?vue&type=style&index=0&id=1d4f8ad0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4f8ad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d4f8ad0')) {
      api.createRecord('1d4f8ad0', component.options)
    } else {
      api.reload('1d4f8ad0', component.options)
    }
    module.hot.accept("./FittingsCheck.vue?vue&type=template&id=1d4f8ad0&scoped=true", function () {
      api.rerender('1d4f8ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Fittings/FittingsCheck/FittingsCheck.vue"
export default component.exports